import {
  CIP_SEQUENCE_TEXT_TO_ID_MAP,
  DEFAULT_CIP_SEQUENCE,
} from "./defaultCIPInformationFields.config";

export const getCIPSequenceIdFromSequenceTextArr = (sequenceTextArr = []) => {
  const filteredSequence = sequenceTextArr.filter(
    (item) => item && item !== "none",
  );
  const sequenceKey = filteredSequence.join("→");
  return CIP_SEQUENCE_TEXT_TO_ID_MAP[sequenceKey];
};

export const getCIPSequenceTextFromCIPSequenceID = (cipSequenceId) => {
  const sequenceKey = Object.keys(CIP_SEQUENCE_TEXT_TO_ID_MAP).find(
    (key) => CIP_SEQUENCE_TEXT_TO_ID_MAP[key] === cipSequenceId,
  );
  return sequenceKey;
};

export const getCIPSequenceTextArrFromCIPSequenceID = (cipSequenceId) => {
  let sequenceKey = getCIPSequenceTextFromCIPSequenceID(cipSequenceId);

  if (!sequenceKey) {
    sequenceKey = DEFAULT_CIP_SEQUENCE.text;
  }

  const sequenceParts = sequenceKey.split("→");
  if (sequenceParts.length === 1) {
    return [sequenceParts[0], "none"];
  }

  return sequenceParts;
};

// sync additive process fields while keeping payload limited to changed values
export const normalizeAdditiveProcessFieldsForSave = (
  changedValues = {}, // object containing the fields that have been changed by the user
  baseValues = {}, // object containing the original values of the fields before any changes were made
) => {
  const normalizedValues = { ...changedValues };

  const syncField = (parentKey, additiveKey) => {
    const parentValue = changedValues[parentKey] ?? baseValues[parentKey];
    const additiveValue = changedValues[additiveKey] ?? baseValues[additiveKey];

    if (Number(parentValue) !== Number(additiveValue)) {
      normalizedValues[additiveKey] = parentValue;
      return;
    }
  };

  syncField("acid_cip_ph", "additive_acid_ph");
  syncField("acid_cip_temp", "additive_acid_temp");
  syncField("acid_cip_duration", "additive_acid_duration");
  syncField("alkali_cip_ph", "additive_alkali_ph");
  syncField("alkali_cip_temp", "additive_alkali_temp");
  syncField("alkali_cip_duration", "additive_alkali_duration");

  return normalizedValues;
};
